import { gql } from "@apollo/client";

export const GridDetail = gql`
    query GridDetail ($id: ID!) {
        grid (id: $id ) {
            id
            insert
            update
            title
            azimuth
            gridItemList {
                total
                gridItems {
                    id
                    insert
                    update
                    type
                    title
                    visible
                    gridAssetList {
                        total
                        gridAssets {
                            id
                            title
                            sortId
                            visible
                            installedBaseNode {
                                id
                                assetLocation {
                                    id
                                    iotConnection {
                                        id
                                        connectionStatus
                                    }
                                }
                            }
                        }
                    }
                    config {
                        id
                        insert
                        update
                        x
                        y
                        w
                        h
                    }
                }
            }
        }
    }
`;
